import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";


function PartnerSettings() {
  const access_token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const [showOverlay, setShowOverlay] = useState(false);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    enable_partner: 1,
    partner_commission_count: "00:01:00",
  });

  const base = process.env.REACT_APP_Baseurl;

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${base}/admin/Partner-Settings/index`, { headers });
      const data = res?.data?.data || {};
      setForm({
        enable_partner: Number(data.enable_partner ?? 1),
        partner_commission_count: data.partner_commission_count || "00:01:00",
      });
    } catch (e) {
      toast.error(e?.response?.data?.message || "Failed to load Partner settings");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (access_token) fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [access_token]);

  const handleToggle = (e) => {
    const { name, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: checked ? 1 : 0 }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Apply time formatting for partner_commission_count field
    if (name === "partner_commission_count") {
      const formattedInput = value.replace(/\D/g, "");

      const formattedTime = formattedInput
        .replace(/^(\d{2})(\d{2})(\d{2})$/, "$1:$2:$3")
        .substr(0, 8);

      setForm((prev) => ({ ...prev, [name]: formattedTime }));
      return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validateTimeFormat = (timeString) => {
    const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
    return timeRegex.test(timeString);
  };

  const handleSave = async () => {
    try {
      // Validate time format
      if (!validateTimeFormat(form.partner_commission_count)) {
        toast.error('Please enter a valid time format (HH:MM:SS), e.g., 00:01:00');
        return;
      }

      setShowOverlay(true);
      const payload = {
        enable_partner: form.enable_partner,
        partner_commission_count: form.partner_commission_count,
      };
      const res = await axios.patch(`${base}/admin/Partner-Settings/update`, payload, { headers });
      const ok = res?.data?.status;
      if (ok) {
        toast.success(res?.data?.message || "Partner settings updated");
      } else {
        toast.error(res?.data?.message || "Failed to update Partner settings");
      }
    } catch (e) {
      toast.error(e?.response?.data?.message || "Failed to update Partner settings");
    } finally {
      setShowOverlay(false);
    }
  };

  return (
    <>
      {showOverlay && <Response_Processing />}
      <AdminSaveHeader heading="Partner Settings" saveText="Update Settings" saveMethod={handleSave} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text="Partner toggles" />

            <div className="d-flex align-items-center justify-content-between py-2">
              <MessageLabel text="Enable Partner Commission" />
              <AdminSwitch
                name="enable_partner"
                checked={form.enable_partner === 1}
                onChange={handleToggle}
              />
            </div>

            <div className="align-items-center justify-content-between py-2">
              <MessageLabel text="Partner Commission Duration (HH:MM:SS)" />

              <AdminCustomInput id="partner_commission_count" data-test-id="partner_commission_count" type="text" maxLength="6" name="partner_commission_count" value={form.partner_commission_count} onChange={handleInputChange} placeHolder={"HH:MM:SS"} />
            </div>

          </Wrapper>
        </LeftWrapper>
      </FormContainer>
    </>
  );
}

export default PartnerSettings;
